/**
 * videoGuides.js - Centralized Video Tutorials & YouTube Config
 * Allows setting YouTube Video IDs or full URLs via environment variables (.env)
 * or updating them directly here.
 */

export const extractYoutubeId = (input) => {
  if (!input || typeof input !== "string") return "";
  const trimmed = input.trim();
  // If already an 11-char ID
  if (/^[a-zA-Z0-9_-]{11}$/.test(trimmed)) {
    return trimmed;
  }
  // If full youtube URL: watch?v=... or youtu.be/... or embed/...
  const match = trimmed.match(
    /(?:youtu\.be\/|youtube\.com\/(?:embed\/|v\/|watch\?v=|watch\?.+&v=))([\w-]{11})/
  );
  return match ? match[1] : trimmed;
};

export const VIDEO_GUIDES = {
  platform: {
    key: "platform",
    title: "AlgoMasters Platform Tour & Video Guide",
    subtitle: "Complete walkthrough: Autonomous AI Bots, Forward & Live Execution, and Dynamic Tiered Profit Locks.",
    videoId: extractYoutubeId(process.env.REACT_APP_YOUTUBE_PLATFORM_VIDEO_ID || ""),
    directUrl: process.env.REACT_APP_YOUTUBE_PLATFORM_URL || "https://www.youtube.com/@AlgoMastersTrading",
    tag: "Platform Overview",
  },
  broker: {
    key: "broker",
    title: "How to Connect Delta Exchange API & Whitelist IP",
    subtitle: "Step-by-step video guide: Generating read/trade API keys on Delta Exchange and whitelisting our server IP.",
    videoId: extractYoutubeId(process.env.REACT_APP_YOUTUBE_BROKER_VIDEO_ID || ""),
    directUrl: process.env.REACT_APP_YOUTUBE_BROKER_URL || "https://www.youtube.com/@AlgoMastersTrading",
    tag: "Delta API Setup",
    whitelistIp: process.env.REACT_APP_DELTA_WHITELIST_IP || "43.204.206.136",
    steps: [
      "Login to your Delta Exchange account and navigate to Settings > API Keys.",
      "Click 'Create API Key' with Read and Trade permissions (Never enable Withdraw).",
      "Under 'IP Restriction / Whitelist', enter AlgoMasters Server IP: 43.204.206.136.",
      "Copy your API Key & API Secret, then paste them into the Add Broker form in AlgoMasters.",
    ],
  },
  aibot: {
    key: "aibot",
    title: "How to Configure & Activate AI Bots",
    subtitle: "Learn how Autonomous AI Sentinels analyze option chains and execute Hedged Spreads & Direct Sells.",
    videoId: extractYoutubeId(process.env.REACT_APP_YOUTUBE_AIBOT_VIDEO_ID || ""),
    directUrl: process.env.REACT_APP_YOUTUBE_AIBOT_URL || "https://www.youtube.com/@AlgoMastersTrading",
    tag: "AI Bots Guide",
    steps: [
      "Choose between Direct Sell (High Yield) or Hedged Spreads (Capped Risk).",
      "Select Forward (Paper) simulation or Live account execution.",
      "Activate the bot — our 30m Autonomous Sentinel handles strikes, roll defense, and exits automatically.",
    ],
  },
};

export const YOUTUBE_CHANNEL_URL = process.env.REACT_APP_YOUTUBE_CHANNEL_URL || "https://www.youtube.com/@AlgoMastersTrading";
